export const loginAsAgencyResponse = {
  creationDateTime: "2023-12-11T11:26:39",
  sessionId: "000068c7-2941-4479-af14-4687ef7c1c5c",
  sessionType: "SingleSignOn",
  sessionName: "JohnDoe Tm",
  userName: "JohnDoe Tm",
  isAuthenticated: true,
};
